import subjectFiltersSignal, {
	setSubjectFilters,
} from '@UI/Pages/Subjects/SubjectList/Filters/Signals/subjectFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { SelectButton } from '@verclam/ui-kit';
import { ArrowDown, ArrowUp } from 'lucide-react';

type Direction = 'ASC' | 'DESC';

const DIRECTION_OPTIONS: readonly { readonly label: string; readonly value: Direction }[] = [
	{ label: 'Croissant', value: 'ASC' },
	{ label: 'Décroissant', value: 'DESC' },
];

const ICON_SIZE = 16;

const renderDirectionIcon = (option: unknown): React.ReactNode => {
	const { value, label } = option as { value: Direction; label: string };

	return value === 'ASC' ? (
		<ArrowUp size={ICON_SIZE} aria-label={label} />
	) : (
		<ArrowDown size={ICON_SIZE} aria-label={label} />
	);
};

const isDirection = (value: unknown): value is Direction => value === 'ASC' || value === 'DESC';

/** Sort direction, defaulting to newest first when the list is sorted by creation date. */
const SortDirectionFilter: React.FC = () => {
	const currentFilters = useSignalValue(subjectFiltersSignal);

	const handleChange = React.useCallback((value: unknown) => {
		if (isDirection(value)) {
			setSubjectFilters(subjectFiltersSignal.peek().setSortDirection(value));
		}
	}, []);

	return (
		<SelectButton
			name="subjectSortDirection"
			label="Sens du tri"
			isLabelHidden
			options={DIRECTION_OPTIONS}
			value={currentFilters.fieldSort?.direction ?? 'DESC'}
			allowEmpty={false}
			itemTemplate={renderDirectionIcon}
			onChange={handleChange}
		/>
	);
};

export default SortDirectionFilter;
